//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable import/no-cycle */
/* eslint-disable object-curly-newline */
import { mdiEyeOutline, mdiEyeOffOutline, mdiMenuDown } from '@mdi/js'
import { ref, onMounted, getCurrentInstance, computed } from '@vue/composition-api'
import { required, emailValidator, minLengthValidator } from '@core/utils/validation'
import useCryptoJs from '@core/utils/useCryptoJs'
import useLogData from '@core/utils/useLogData'
import usePhone from '@core/utils/usePhone'
import useCountry from '@core/utils/useCountry'
import themeConfig from '@themeConfig'
import { useRouter } from '@core/utils'
import { registerUser } from '@api'
import { useUtils } from '@core/libs/i18n'
import store from '@/store'
import parsePhoneNumber from 'libphonenumber-js'

export default {
  setup() {
    const { router } = useRouter()
    const { t } = useUtils()
    const { encrypt } = useCryptoJs()
    const { logData, currentLogData, updateLogData } = useLogData()
    const { phoneCodeOptions, initPhoneConfig } = usePhone()
    const { getCountryCode } = useCountry()
    const vm = getCurrentInstance().proxy

    const form = ref(null)
    const loginData = ref({})
    const registerData = ref({
      firstName: null,
      lastName: null,
      email: null,
      password: null,
      validateData: 'YES',
      phoneCode: '',
      phoneNumber: '',
      fullPhone: null,
    })
    const initCode = ref(null)
    const errorMessages = ref([])
    const isPasswordVisible = ref(false)
    const isPasswordConfirmVisible = ref(false)
    const acceptedTerms = ref(false)

    const isFormValid = computed(() => {
      if (
        registerData.value.firstName
        && registerData.value.lastName
        && registerData.value.fullPhone
        && registerData.value.email
        && registerData.value.password
        && minLengthValidator(registerData.value.password, 6) === true
        && acceptedTerms.value
      ) return true

      return false
    })

    const createSubmit = async () => {
      if (form.value.validate() && acceptedTerms.value) {
        const bodyRegister = {
          first_name: registerData.value.firstName,
          last_name: registerData.value.lastName,
          phone_number: registerData.value.fullPhone,
          email: registerData.value.email,
          password: registerData.value.password,
          validate_data: 'YES',
          type: loginData.value.type,
        }
        const encryptBodyRegister = encrypt(bodyRegister)
        const resp = await registerUser(encryptBodyRegister)
        if (resp.ok) {
          const body = {
            code: loginData.value.type === 'EMAIL' ? loginData.value.code : loginData.value.fullPhone,
            type: loginData.value.type,
            join_game: loginData.value.joinGame,
            match_code: loginData.value.matchCode,
            login_route: 'LOGIN_PAGE',
            password: registerData.value.password,
          }
          const encryptBody = encrypt(body)

          const userAbility = [
            {
              action: 'manage',
              subject: 'all',
            },
          ]
          vm.$ability.update(userAbility)

          const payload = {
            data: encryptBody,
            redirect: logData.value.redirect,
            facility: logData.value.facility,
            field: logData.value.field,
            date: logData.value.date,
            time: logData.value.time,
            slot: logData.value.slot,
            pay: logData.value.pay,
            reservationCode: logData.value.reservationCode,
            showPay: logData.value.showPay,
            team: logData.value.team,
            chooseTeam: logData.value.chooseTeam,
            payType: logData.value.payType,
          }

          // remove team
          store.dispatch('auth/loginUserAction', payload)
        } else if (resp.message.code === 'U019') {
          logData.value.avatar = resp.data.avatar
          logData.value.fullname = resp.data.fullname
          logData.value.info = resp.data.info
          logData.value.typeIsThisYou = resp.data.type
          logData.value.username = resp.data.its_you_username
          logData.value.register = registerData.value
          updateLogData(logData.value)
          router.push({ name: 'auth-is-this-you' })
        }
      }
    }

    const validatePhone = e => {
      if (registerData.value.phoneCode && e) {
        const phoneNumberJS = parsePhoneNumber(e, registerData.value.phoneCode)
        if (phoneNumberJS) {
          if (phoneNumberJS.isValid()) {
            registerData.value.fullPhone = phoneNumberJS.number

            return true
          }
        }
      }
      registerData.value.fullPhone = ''

      return 'Invalid number'
    }

    onMounted(async () => {
      Object.assign(logData.value, currentLogData.value)
      logData.value.loginRoute = 'LOGIN_PAGE'
      loginData.value = logData.value

      const countryCode = getCountryCode()
      if (countryCode) {
        const codeFinded = phoneCodeOptions.value.find(e => e.value === countryCode)
        if (codeFinded) initCode.value = countryCode
        else initCode.value = 'US'
      }

      if (currentLogData.value) {
        if (loginData.value.type === 'EMAIL') {
          registerData.value.email = loginData.value.code
          registerData.value.phoneCode = loginData.value.phoneCode || initCode.value
        } else {
          registerData.value.phoneNumber = loginData.value.phoneNumber
          registerData.value.phoneCode = loginData.value.phoneCode
          registerData.value.fullPhone = loginData.value.fullPhone
        }
      }
    })

    return {
      form,
      loginData,
      registerData,
      errorMessages,
      isPasswordVisible,
      isPasswordConfirmVisible,
      isFormValid,
      acceptedTerms,
      phoneCodeOptions,

      // themeConfig
      appLogoTitle: themeConfig.app.logoTitle,

      createSubmit,
      validatePhone,
      initPhoneConfig,

      t,

      validators: {
        required,
        emailValidator,
        minLengthValidator,
      },

      icons: {
        mdiEyeOutline,
        mdiEyeOffOutline,
        mdiMenuDown,
      },
    }
  },
}
